import React from "react";

import { INSULATED_APC_TYPE_OPTIONS } from "../../../data";
import { CardRow, StructureSection } from "../OpenBoxQuotes/BoxStructureFields";
import {
  AccessoryNoteCard,
  AccessoryQuantityCard,
  AccessoryQuantityNoteCard,
  AccessoryTypeQuantityNoteCard,
} from "./AccessoriesCards";
import { OpenBasketCard, ToolboxCard } from "./AccessoriesStorage";
import { insulatedKey } from "./BoxStructureCards";

const AccessoriesTying = () => (
  <>
    <StructureSection titleKey={insulatedKey("SECTIONS.TYING")} plain>
      <CardRow columns={2}>
        <AccessoryQuantityNoteCard
          cardKey="recessedRings"
          titleKey={insulatedKey("CARDS.RECESSED_RINGS")}
        />
        <AccessoryTypeQuantityNoteCard
          cardKey="apcRings"
          titleKey={insulatedKey("CARDS.APC_RINGS")}
          options={INSULATED_APC_TYPE_OPTIONS}
        />
      </CardRow>
    </StructureSection>

    <StructureSection titleKey={insulatedKey("SECTIONS.STORAGE")}>
      <CardRow columns={2}>
        <ToolboxCard />
        <OpenBasketCard />
      </CardRow>
      <CardRow columns={2}>
        <AccessoryQuantityCard
          cardKey="palletJackMount"
          titleKey={insulatedKey("CARDS.PALLET_JACK_MOUNT")}
        />
        <AccessoryNoteCard
          cardKey="jerrycan"
          titleKey={insulatedKey("CARDS.JERRYCAN")}
        />
      </CardRow>
    </StructureSection>
  </>
);

export default AccessoriesTying;
